module.exports = __webpack_public_path__ + "img/talco o polvo dermico.4a7560b4.png";